<div class="banner">
    <img src="assets/icons/logo-ppa.svg"/>
</div>
